import { SVGProps } from 'react'

const CarCircle = (props: SVGProps<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}>
      <rect width="24" height="24" rx="12" fill="currentColor" />
      <path
        d="M6.09375 9.5625L7.35938 5.76562H16.6406L17.9062 9.5625M16.6406 13.7812C16.305 13.7812 15.983 13.6479 15.7457 13.4106C15.5083 13.1732 15.375 12.8513 15.375 12.5156C15.375 12.18 15.5083 11.858 15.7457 11.6207C15.983 11.3833 16.305 11.25 16.6406 11.25C16.9763 11.25 17.2982 11.3833 17.5356 11.6207C17.7729 11.858 17.9062 12.18 17.9062 12.5156C17.9062 12.8513 17.7729 13.1732 17.5356 13.4106C17.2982 13.6479 16.9763 13.7812 16.6406 13.7812ZM7.35938 13.7812C7.02371 13.7812 6.70179 13.6479 6.46444 13.4106C6.22709 13.1732 6.09375 12.8513 6.09375 12.5156C6.09375 12.18 6.22709 11.858 6.46444 11.6207C6.70179 11.3833 7.02371 11.25 7.35938 11.25C7.69504 11.25 8.01696 11.3833 8.25431 11.6207C8.49166 11.858 8.625 12.18 8.625 12.5156C8.625 12.8513 8.49166 13.1732 8.25431 13.4106C8.01696 13.6479 7.69504 13.7812 7.35938 13.7812ZM17.8387 5.34375C17.67 4.85438 17.1975 4.5 16.6406 4.5H7.35938C6.8025 4.5 6.33 4.85438 6.16125 5.34375L4.40625 10.4062V17.1562C4.40625 17.38 4.49514 17.5946 4.65338 17.7529C4.81161 17.9111 5.02622 18 5.25 18H6.09375C6.31753 18 6.53214 17.9111 6.69037 17.7529C6.8486 17.5946 6.9375 17.38 6.9375 17.1562V16.3125H17.0625V17.1562C17.0625 17.38 17.1514 17.5946 17.3096 17.7529C17.4679 17.9111 17.6825 18 17.9062 18H18.75C18.9738 18 19.1884 17.9111 19.3466 17.7529C19.5049 17.5946 19.5938 17.38 19.5938 17.1562V10.4062L17.8387 5.34375Z"
        fill="#272727"
      />
    </svg>
  )
}

export default CarCircle
